import { render, staticRenderFns } from "./ConsignmentList.vue?vue&type=template&id=5c4d686c&scoped=true&"
import script from "./ConsignmentList.vue?vue&type=script&lang=js&"
export * from "./ConsignmentList.vue?vue&type=script&lang=js&"
import style0 from "./ConsignmentList.vue?vue&type=style&index=0&id=5c4d686c&lang=scss&scoped=true&"
import style1 from "./ConsignmentList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4d686c",
  null
  
)

export default component.exports